module.exports = __webpack_public_path__ + "static/apple-touch-icon.2a6b054d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/apple-touch-icon.png
// module id = 553
// module chunks = 213534597649335